<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />

    <CMenu/>

    <CHeaderNav style="width:auto;">
      <!-- <CHeaderNavItem class="px-3">
        <CSelect
          class="mt-3"
          :options="langs"
          :value="locale"
          @update:value="selectLocale"
        />
      </CHeaderNavItem> -->
      <!-- <CHeaderNavItem class="px-3">
        <button 
          @click="sendNotify()" 
          class="c-header-nav-btn"
        >
          Notify
        </button>
      </CHeaderNavItem> -->
      <!-- <CHeaderNavItem class="px-3">
        <button 
          @click="sendGroups()" 
          class="c-header-nav-btn"
        >
          Groups
        </button>
      </CHeaderNavItem> -->
      <CHeaderNavItem class="px-3 d-md-down-none">
        <search-orders :header="true"></search-orders>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
          v{{$store.state.version}}
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <button 
          @click="() => $store.commit('toggle', 'darkMode')" 
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun"/>
          <CIcon v-else name="cil-moon"/>
        </button>
      </CHeaderNavItem>
      <TheHeaderDropdownNotif/>
      <!-- <TheHeaderDropdownTasks/> -->
      <TheHeaderDropdownMssgs/>
      <TheHeaderDropdownAccnt/>
      <CHeaderNavItem class="px-3">
        <button
          in-header
          class="c-header-nav-btn"
          @click="$store.commit('toggle', 'asideShow')"
        >
          <CIcon size="lg" name="cil-applications-settings" class="mr-2"/>
        </button>
      </CHeaderNavItem>
    </CHeaderNav>

    <CSubheader class="pt-1 pl-2 text-center d-lg-none">
      <search-orders :header="true"></search-orders>
    </CSubheader>
 
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
      <other-customer-orders v-if="$route.matched.some(({ name }) => name === 'Order Display') && $store.state.currentOrder"></other-customer-orders>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'
import SearchOrders from './../views/components/search_orders'
import OtherCustomerOrders from './../views/components/other_customer_orders'
import CMenu from './Menu'
import axios from 'axios'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
    CMenu,
    SearchOrders,
    OtherCustomerOrders
  },
  data: function(){
    return {
      langs: [],
      locale: 'en',
    }
  },
  watch: {
    '$router.currentRoute.name': function (newVal, oldVal) {
      console.log('router change')
    }
  },
  computed: {
    showCustomer() {
      var r = false
      if (this.$router.currentRoute) {
        if (this.$router.currentRoute.name === 'Order Display') {
          r = true
        }
      }
      console.log('show customer')
      console.log(this.$router)
      return r
    }
  },
  methods:{
    selectLocale: function(option){
      localStorage.setItem("locale", option)
      this.$i18n.set( option )
      //location.reload()
      this.$emit('change-locale', option)
    },
    sendNotify: function () {
      axios.post(this.$apiAdress + '/api/notifications/sendNotify?token=' + window.localStorage.getItem('api_token')).then(response => {
        console.log(response)
      })
    },
    sendGroups: function () {
      const postData = {
        groups: ['598A135'],
        name: 'as400',
        token: 'DR5FpxLpxNI1tKjtpobYQuOJ9gacCj1Zdfh4ZbB228UIwlV3A9'
      }
      axios.post(this.$apiAdress + '/api/updateFromAs400/updateGroupsTest?token=' + window.localStorage.getItem('api_token'), postData).then(response => {
        console.log(response)
      })
    }
  },
  mounted () {
    let self = this;
    if(typeof localStorage.locale !== 'undefined'){
      this.locale = localStorage.getItem("locale")
    }
    console.log('header router')
    console.log(this.$router)
    // var socket = io.connect('http://localhost:6001')
    // console.log('echooooo')
    // console.log(Echo)
    // Echo.private(`orderentry_database_private-user.12`).notification((notification) => {
    //   console.log('notify')
    //   console.log(notification)
    // })
    // Echo.private(`orderentry_database_private-user`).listen('Illuminate\Notifications\Events\BroadcastNotificationCreated', (payload) => {
    //     console.log('ayyoooo')
    //     console.log(payload);
    // });
    // axios.get( this.$apiAdress + '/api/langlist?token=' + localStorage.getItem("api_token") )
    // .then(function (response) {
    //   self.langs = [];
    //   for(let i =0; i<response.data.length; i++){
    //     self.langs.push({
    //       value: response.data[i].short_name,
    //       label: response.data[i].name
    //     });
    //   }
    // }).catch(function (error) {
    //   console.log(error)
    //   self.$router.push({ path: '/login' })
    // });
  }
}
</script>
